"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCursorClick1 = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconCursorClick1 = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 1C9.55229 1 10 1.44772 10 2V3.5C10 4.05228 9.55229 4.5 9 4.5C8.44772 4.5 8 4.05228 8 3.5V2C8 1.44772 8.44772 1 9 1Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.29289 3.29289C3.68342 2.90237 4.31658 2.90237 4.70711 3.29289L5.76777 4.35355C6.15829 4.74408 6.15829 5.37724 5.76777 5.76777C5.37724 6.15829 4.74408 6.15829 4.35355 5.76777L3.29289 4.70711C2.90237 4.31658 2.90237 3.68342 3.29289 3.29289Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.76777 13.7071C6.15829 13.3166 6.15829 12.6834 5.76777 12.2929C5.37724 11.9024 4.74408 11.9024 4.35355 12.2929L3.29289 13.3536C2.90237 13.7441 2.90237 14.3772 3.29289 14.7678C3.68342 15.1583 4.31658 15.1583 4.70711 14.7678L5.76777 13.7071Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.7678 3.29289C15.1583 3.68342 15.1583 4.31658 14.7678 4.70711L13.7071 5.76777C13.3166 6.15829 12.6834 6.15829 12.2929 5.76777C11.9024 5.37724 11.9024 4.74408 12.2929 4.35355L13.3536 3.29289C13.7441 2.90237 14.3772 2.90237 14.7678 3.29289Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 8C1.44772 8 1 8.44772 1 9C1 9.55229 1.44772 10 2 10H3.5C4.05228 10 4.5 9.55229 4.5 9C4.5 8.44772 4.05228 8 3.5 8H2Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.70706 7.47947C9.50146 7.41608 9.28693 7.34995 9.10414 7.31146C8.92239 7.2732 8.59215 7.21844 8.23933 7.34791C7.82569 7.4997 7.49971 7.82568 7.34791 8.23932C7.21844 8.59214 7.2732 8.92239 7.31146 9.10413C7.34994 9.28692 7.41608 9.50146 7.47946 9.70706L10.9591 21.0031C11.0378 21.259 11.1155 21.5112 11.1961 21.7089C11.2685 21.8862 11.4259 22.2463 11.7866 22.4761C12.1902 22.7333 12.6923 22.7824 13.1382 22.6084C13.5365 22.4529 13.7608 22.1302 13.8662 21.9702C13.9836 21.7919 14.1087 21.5596 14.2356 21.3238L16.7165 16.7165L21.3238 14.2356C21.5596 14.1087 21.7919 13.9837 21.9702 13.8662C22.1301 13.7609 22.4528 13.5366 22.6083 13.1382C22.7824 12.6924 22.7333 12.1903 22.4761 11.7866C22.2462 11.426 21.8862 11.2685 21.7089 11.1962C21.5112 11.1155 21.259 11.0379 21.0031 10.9591L9.70706 7.47947Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M15.8645 16.1896L13.3727 20.817C13.0881 21.3457 12.9457 21.61 12.7745 21.6769C12.6259 21.7349 12.4585 21.7185 12.324 21.6328C12.1689 21.534 12.0806 21.2471 11.9038 20.6733L8.44519 9.44525C8.3008 8.97651 8.2286 8.74213 8.28669 8.58383C8.33729 8.44595 8.44595 8.33729 8.58383 8.2867C8.74213 8.22861 8.9765 8.3008 9.44525 8.44519L20.6732 11.9038C21.247 12.0806 21.5339 12.169 21.6327 12.324C21.7185 12.4586 21.7348 12.6259 21.6768 12.7745C21.61 12.9458 21.3456 13.0881 20.817 13.3728L16.1896 15.8645C16.111 15.9068 16.0717 15.9279 16.0374 15.9551C16.0068 15.9792 15.9792 16.0068 15.9551 16.0374C15.9279 16.0717 15.9068 16.111 15.8645 16.1896Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconCursorClick1 = IconCursorClick1;
//# sourceMappingURL=IconCursorClick1.js.map